import React, { useState } from "react";
import { Menu } from "primereact/menu";
import { Avatar } from "primereact/avatar";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useNavigate } from "react-router-dom";
import Editprofile from "./Editprofile";
import { Domain, Workspace } from "../../path";
import useGet from "../../Hooks/useGet";
import { useEffect } from "react";
import { Set_Loader } from "../../Redux/Action/LoaderAction";
import { useDispatch } from "react-redux";

const Sidebarleft = ({ ModalHandler }) => {
  const [EditprofileModal, setEditprofileModal] = useState(false);
  const Navigation = useNavigate();
  const Dispatch = useDispatch();
  const [Profiledetails, setProfiledetails] = useState(null);
  const Userdetail = useGet(`${Workspace[Domain].API_Path}/edit_profile`);
  const accept = () => {
    ModalHandler("logout", false);
    localStorage.removeItem("TEACHER_TOKEN");
    Navigation("/login", { replace: true });
    window.location.reload();
  };

  const reject = () => {};
  const logoutModal = () => {
    confirmDialog({
      draggable: false,
      style: { width: "100%", maxWidth: "400px", background: "white" },
      message: "Do you want to Logout?",
      header: "Logout",
      icon: "pi pi-fw pi-sign-out",
      acceptClassName: "p-button-danger",
      accept,
      reject,
      contentStyle: { padding: "0px 10px" },
    });
  };
  let items = [
    {
      template: (item, options) => {
        return (
          <div onClick={(e) => options.onClick(e)} className={"p-3"}>
            <div className="flex items-center">
              <Avatar
                image="https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/User-avatar.svg/1024px-User-avatar.svg.png"
                className="mr-2 border-2 p-1"
                shape="circle"
              />
              <p className="font-bold">{Profiledetails?.teacher_name || "-"}</p>
            </div>
            <div className="">
              <p className="font-bold my-2">
                <i className="pi pi-phone mr-2"></i>
                {Profiledetails?.users_mobile || "-"}
              </p>
              <p className="font-bold">
                <i className="pi pi-envelope mr-2"></i>
                {Profiledetails?.users_email || "-"}
              </p>
            </div>
          </div>
        );
      },
    },
    { separator: true },
    {
      label: "Edit Profile",
      icon: "pi pi-fw pi-user",
      command: () => {
        setEditprofileModal(true);
      },
    },
    {
      label: "Logout",
      icon: "pi pi-fw pi-sign-out",
      command: () => {
        // ModalHandler("logout", true);
        logoutModal();
      },
    },
  ];

  useEffect(() => {
    Userdetail.refetch("");
    return () => {
      setProfiledetails(null);
      setEditprofileModal(false);
    };
  }, []);

  useEffect(() => {
    if (Userdetail.data) {
      switch (Userdetail.data?.status) {
        case 200:
          Dispatch(Set_Loader(false));
          setProfiledetails(() => Userdetail.data?.body[0]);
          break;

        default:
          break;
      }
    }
  }, [Userdetail.data]);

  return (
    <div className="w-full">
      <ConfirmDialog />
      <Editprofile
        EditprofileModal={EditprofileModal}
        setEditprofileModal={setEditprofileModal}
        Profiledetails={Profiledetails}
        setProfiledetails={setProfiledetails}
      />
      <Menu model={items} className="w-full" style={{ width: "100%" }} />
    </div>
  );
};

export default Sidebarleft;
